import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 relative" }
const _hoisted_2 = { class: "tooltip-new" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { style: {"flex":"1"} }, "How do I provide liquidity?", -1)

import useTokens from '@/composables/useTokens';
    import TutorialLiquidityTooltip from '@/components/tooltips/TutorialLiquidityTooltip';
    
    type Props = {
      tokenAddress: string;
      farmId: string;
      hasUnstakedBpt: boolean;
      hasFarmRewards: boolean;
    };    
    /**
     * STATE
     */
  
    
    
export default _defineComponent({
  setup(__props) {

    const {loading} = useTokens();
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(TutorialLiquidityTooltip))
    ])
  ]))
}
}

})